/* eslint-disable no-undef */
import axios from 'axios';
/**
 https://hdc-api-dev.collegeplanning-nonprod.collegeboard.org/admin/plugins/content-manager/collectionType/application::references.references/29

https://hdc-api-qa.collegeplanning-nonprod.collegeboard.org/organizations

https://hdc-api-staging.collegeplanning-nonprod.collegeboard.org/organizations

https://hdcadmin.collegeboard.org/organizations (Prod)
 */
export const newApi = axios.create({
  baseURL: process.env.ENV==='prod'?
    'https://hdcadmin.collegeboard.org':
    `https://hdc-api-${process.env.ENV}.collegeplanning-nonprod.collegeboard.org`
});

